var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agency-exchange full-height" },
    [
      _c(
        "div",
        { staticClass: "toolbar" },
        [
          _c("el-input", {
            staticClass: "toolbar-search",
            attrs: { size: "mini", placeholder: "搜尋標題...", clearable: "" },
            on: { clear: _vm.handleFilter },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.qry,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "qry", $$v)
              },
              expression: "listQuery.qry",
            },
          }),
          _c("el-button", {
            attrs: {
              size: "mini",
              type: "primary",
              icon: "el-icon-search",
              title: "搜尋",
            },
            on: { click: _vm.handleFilter },
          }),
          _c("el-button", {
            attrs: {
              size: "mini",
              type: "success",
              icon: "el-icon-plus",
              title: "新增文章",
            },
            on: { click: _vm.addData },
          }),
          _c("el-button", {
            attrs: { size: "mini", icon: "el-icon-refresh", title: "重整" },
            on: { click: _vm.refresh },
          }),
          _c("el-button", {
            attrs: {
              size: "mini",
              type: _vm.listQuery.onlyMine ? "warning" : "",
              icon: "el-icon-view",
              title: "看自己發過的",
            },
            on: { click: _vm.toggleOnlyMine },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tag-bar" },
        [
          _c(
            "span",
            {
              staticClass: "tag-chip",
              class: { active: _vm.listQuery.tagId === null },
              on: {
                click: function ($event) {
                  return _vm.selectTag(null)
                },
              },
            },
            [_vm._v(" 全部 ")]
          ),
          _vm._l(_vm.enabledTagList, function (t) {
            return _c(
              "span",
              {
                key: t.id,
                staticClass: "tag-chip",
                class: { active: _vm.listQuery.tagId === t.id },
                style: _vm.chipStyle(t),
                on: {
                  click: function ($event) {
                    return _vm.selectTag(t.id)
                  },
                },
              },
              [_vm._v(" " + _vm._s(t.tagName) + " ")]
            )
          }),
          _vm.isInternal
            ? _c("el-button", {
                staticClass: "tag-add-btn",
                attrs: {
                  size: "mini",
                  icon: "el-icon-plus",
                  circle: "",
                  title: "新增類別",
                },
                on: { click: _vm.openTagDialog },
              })
            : _vm._e(),
          _vm.isInternal
            ? _c("el-button", {
                staticClass: "tag-add-btn",
                attrs: {
                  size: "mini",
                  type: "danger",
                  icon: "el-icon-delete",
                  circle: "",
                  title: "刪除類別",
                },
                on: { click: _vm.openTagDeleteDialog },
              })
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "disclaimer-bar" },
        [
          _c("i", { staticClass: "el-icon-warning-outline disclaimer-icon" }),
          !_vm.disclaimerEditing
            ? [
                _c("span", { staticClass: "disclaimer-text" }, [
                  _vm._v(_vm._s(_vm.disclaimer || "（尚無公告）")),
                ]),
                _vm.isInternal
                  ? _c(
                      "el-button",
                      {
                        staticClass: "disclaimer-btn",
                        attrs: {
                          type: "text",
                          size: "mini",
                          icon: "el-icon-edit",
                        },
                        on: { click: _vm.startEditDisclaimer },
                      },
                      [_vm._v(" 編輯 ")]
                    )
                  : _vm._e(),
              ]
            : [
                _c("el-input", {
                  staticClass: "disclaimer-input",
                  attrs: {
                    size: "mini",
                    type: "textarea",
                    autosize: { minRows: 1, maxRows: 4 },
                    maxlength: "500",
                  },
                  model: {
                    value: _vm.disclaimerDraft,
                    callback: function ($$v) {
                      _vm.disclaimerDraft = $$v
                    },
                    expression: "disclaimerDraft",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "disclaimer-btn",
                    attrs: {
                      type: "primary",
                      size: "mini",
                      loading: _vm.disclaimerSaving,
                    },
                    on: { click: _vm.saveDisclaimerText },
                  },
                  [_vm._v(" 儲存 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "disclaimer-btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.cancelEditDisclaimer },
                  },
                  [_vm._v("取消")]
                ),
              ],
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "card-wall",
        },
        [
          _vm._l(_vm.list, function (row) {
            return _c(
              "el-card",
              {
                key: row.id,
                staticClass: "article-card",
                class: { "is-draft": _vm.isDraft(row) },
                attrs: { "body-style": { padding: "0px" }, shadow: "hover" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.openDetail(row.id)
                  },
                },
              },
              [
                _c("div", { staticClass: "card-cover" }, [
                  _c("img", {
                    attrs: { src: _vm.coverOf(row), alt: "cover" },
                    on: { error: _vm.onCoverError },
                  }),
                  row.tagName
                    ? _c(
                        "span",
                        {
                          staticClass: "card-tag",
                          style: { backgroundColor: row.tagColor || "#909399" },
                        },
                        [_vm._v(" " + _vm._s(row.tagName) + " ")]
                      )
                    : _vm._e(),
                  _vm.isDraft(row)
                    ? _c("span", { staticClass: "card-draft-badge" }, [
                        _vm._v("尚未發佈"),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "card-info" }, [
                  _c(
                    "div",
                    { staticClass: "card-title", attrs: { title: row.title } },
                    [_vm._v(_vm._s(row.title))]
                  ),
                  _c("div", { staticClass: "card-footer" }, [
                    _c("div", { staticClass: "card-author" }, [
                      _c("img", {
                        staticClass: "card-avatar",
                        attrs: {
                          src: row.authorAvatar || _vm.defaultAvatar,
                          alt: "avatar",
                        },
                        on: { error: _vm.onAvatarError },
                      }),
                      _c("span", { staticClass: "card-author-name" }, [
                        _vm._v(_vm._s(row.authorName || "匿名")),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "card-meta" }, [
                    _c("span", { staticClass: "card-date" }, [
                      _vm._v(_vm._s(_vm.formatDate(row.buildDate))),
                    ]),
                    _c("span", { staticClass: "card-comment" }, [
                      _c("i", { staticClass: "el-icon-chat-dot-round" }),
                      _vm._v(" " + _vm._s(row.commentCount || 0) + " "),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          !_vm.listLoading && _vm.list.length === 0
            ? _c(
                "div",
                { staticClass: "empty-tip" },
                [_c("el-empty", { attrs: { description: "目前沒有文章" } })],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0", "margin-top": "10px" },
        attrs: {
          layout: "total, prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.detailVisible,
            fullscreen: "",
            "show-close": false,
            "custom-class": "detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
            closed: _vm.onDetailClosed,
          },
        },
        [
          _vm.detailVisible
            ? _c("detail", {
                attrs: { id: _vm.currentId },
                on: {
                  edit: _vm.onDetailEdit,
                  deleted: _vm.onDetailDeleted,
                  changed: _vm.getList,
                  close: function ($event) {
                    _vm.detailVisible = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.formData.id ? "編輯文章" : "新增文章",
            visible: _vm.dialogFormVisible,
            width: "90%",
            top: "2%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            closed: _vm.onFormDialogClosed,
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              staticClass: "box-card",
            },
            [
              _c(
                "el-form",
                { ref: "dynamicValidateForm", attrs: { model: _vm.formData } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "封面照",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("Upload", {
                        ref: "uploadRef",
                        attrs: {
                          accept: ".jpg,.jpeg,.png",
                          payload: _vm.formData,
                          "data-obj": _vm.fileObj,
                          limitText:
                            "圖片尺寸建議 420x250，須為 .jpg/.jpeg/.png 格式，單檔不超過 2MB",
                          "limit-file-count": 1,
                          "use-drag": false,
                          action: "AgencyExchange/saveArticle",
                          "auto-upload": false,
                          "show-file-list": true,
                          "form-on-loading-parent": _vm.formLoading,
                          "btn-txt": "上傳封面",
                          "before-file-list":
                            _vm.formData.fileInfo &&
                            _vm.formData.fileInfo.length
                              ? _vm.formData.fileInfo[0].files
                              : [],
                        },
                        on: { remove: _vm.onCoverRemove },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "標題",
                        "label-width": _vm.formLabelWidth,
                        prop: "title",
                        rules: [
                          {
                            required: true,
                            message: "請輸入標題",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "100",
                          "show-word-limit": "",
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.formData.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "title", $$v)
                          },
                          expression: "formData.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "文章類別",
                        "label-width": _vm.formLabelWidth,
                        prop: "tagId",
                        rules: [
                          {
                            required: true,
                            message: "請選擇文章類別",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "請選擇文章類別" },
                          model: {
                            value: _vm.formData.tagId,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "tagId", $$v)
                            },
                            expression: "formData.tagId",
                          },
                        },
                        _vm._l(_vm.formTagOptions, function (t) {
                          return _c("el-option", {
                            key: t.id,
                            attrs: { label: t.tagName, value: t.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "內文",
                        "label-width": _vm.formLabelWidth,
                        prop: "content",
                      },
                    },
                    [
                      _c("tinymce", {
                        ref: "tinymce",
                        attrs: { height: 450, type: 29 },
                        model: {
                          value: _vm.formData.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "content", $$v)
                          },
                          expression: "formData.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否公開",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "公開",
                          "inactive-text": "草稿",
                        },
                        model: {
                          value: _vm.formData.isPublic,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "isPublic", $$v)
                          },
                          expression: "formData.isPublic",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.formLoading },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v(" 儲 存 ")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增類別",
            visible: _vm.tagDialogVisible,
            width: "420px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tagDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "tagForm",
              attrs: { model: _vm.tagForm, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "類別名稱",
                    prop: "tagName",
                    rules: [
                      {
                        required: true,
                        message: "請輸入類別名稱",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50", "show-word-limit": "" },
                    model: {
                      value: _vm.tagForm.tagName,
                      callback: function ($$v) {
                        _vm.$set(_vm.tagForm, "tagName", $$v)
                      },
                      expression: "tagForm.tagName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "配色" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.tagForm.color,
                      callback: function ($$v) {
                        _vm.$set(_vm.tagForm, "color", $$v)
                      },
                      expression: "tagForm.color",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 9999, "controls-position": "right" },
                    model: {
                      value: _vm.tagForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.tagForm, "sort", $$v)
                      },
                      expression: "tagForm.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.tagSaving },
                  on: { click: _vm.saveTagData },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.tagDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "刪除類別",
            visible: _vm.tagDeleteDialogVisible,
            width: "420px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tagDeleteDialogVisible = $event
            },
          },
        },
        [
          _c("p", { staticClass: "tag-delete-hint" }, [
            _vm._v(
              " 刪除後的類別不再出現在篩選與發文選單，既有文章的分類顯示不受影響。 "
            ),
          ]),
          _vm.enabledTagList.length === 0
            ? _c("div", { staticClass: "tag-delete-empty" }, [
                _vm._v("目前沒有可刪除的類別。"),
              ])
            : _c(
                "ul",
                { staticClass: "tag-delete-list" },
                _vm._l(_vm.enabledTagList, function (t) {
                  return _c(
                    "li",
                    { key: t.id, staticClass: "tag-delete-item" },
                    [
                      _c("span", { staticClass: "tag-delete-name" }, [
                        _c("i", {
                          staticClass: "tag-delete-dot",
                          style: { backgroundColor: t.color || "#409EFF" },
                        }),
                        _vm._v(" " + _vm._s(t.tagName) + " "),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            loading: _vm.tagDeletingId === t.id,
                            disabled: _vm.tagDeletingId !== null,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteTagData(t)
                            },
                          },
                        },
                        [_vm._v(" 刪除 ")]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
          _vm.disabledTagList.length > 0
            ? [
                _c("p", { staticClass: "tag-delete-hint tag-delete-section" }, [
                  _vm._v("已刪除的類別（可復原）"),
                ]),
                _c(
                  "ul",
                  { staticClass: "tag-delete-list" },
                  _vm._l(_vm.disabledTagList, function (t) {
                    return _c(
                      "li",
                      { key: t.id, staticClass: "tag-delete-item" },
                      [
                        _c(
                          "span",
                          { staticClass: "tag-delete-name is-disabled" },
                          [
                            _c("i", {
                              staticClass: "tag-delete-dot",
                              style: { backgroundColor: t.color || "#409EFF" },
                            }),
                            _vm._v(" " + _vm._s(t.tagName) + " "),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              loading: _vm.tagDeletingId === t.id,
                              disabled: _vm.tagDeletingId !== null,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.restoreTagData(t)
                              },
                            },
                          },
                          [_vm._v(" 復原 ")]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.tagDeleteDialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }